import { render } from "./suggestView.vue?vue&type=template&id=341f128e&scoped=true&ts=true"
import script from "./suggestView.vue?vue&type=script&lang=ts&config=true"
export * from "./suggestView.vue?vue&type=script&lang=ts&config=true"

import "./suggestView.vue?vue&type=style&index=0&id=341f128e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341f128e"]])

export default __exports__